function ScrollHide(listen, target, offsetY) {
  this.listenEl = listen
  this.targetEl = target
  this.unmount = undefined
  this.posY = undefined
  this.posY_m = undefined
  this.offsetY = offsetY || 0
  this.prevent = false
  this.init()
  this.mount()
}
ScrollHide.prototype.init = function () {
  this.targetEl.style.transition = "300ms all"
  this.posY = this.targetEl.scrollTop
}
ScrollHide.prototype.mount = function () {
  var that = this
  function handleResize() {
    that.prevent = true
  }
  function handleWheel() {
    that.prevent = false
  }
  function handleTouch() {
    that.prevent = false
  }
  function handleScroll(e) {
    var change = e.target.scrollTop - that.posY
    that.posY = e.target.scrollTop
    if (that.posY <= that.offsetY) {
      that.targetEl.style.transform = "none"
      return
    }
    if (that.prevent) return
    if (change <= 0) {
      that.targetEl.style.transform = "none"
      return
    }
    if (change > 0) {
      that.targetEl.style.transform = "translateY(-100%)"
      return
    }
  }
  window.addEventListener("resize", handleResize)
  this.listenEl.addEventListener("wheel", handleWheel)
  this.listenEl.addEventListener("touchstart", handleTouch)
  this.listenEl.addEventListener("scroll", handleScroll)
  this.unmount = function () {
    window.removeEventListener("resize", handleResize)
    this.listenEl.removeEventListener("wheel", handleWheel)
    this.listenEl.removeEventListener("touchstart", handleTouch)
    this.listenEl.removeEventListener("scroll", handleScroll)
  }
}

export default ScrollHide
